import React from 'react'
import styles from './display.module.css'

export const Loading = ({ loading }) => {
  return (loading && <div className={`${styles.loader}`} />) || null
}
